import {
  IBookingSimple,
  PresenceType,
  IPresenceUpdate,
  BookingStatus,
} from '../../../../Models/DTO/Booking.models';
import {
  SortByDateDescending,
  SortByNameAscending,
  SortByNameDescending,
  SortByDateAscending,
} from '../../../../Helpers/Sorting.helpers';

export const makeHandleSelectAll = (selectAll: any) => (
  selectedBookings: string[],
  sortedBookings: IBookingSimple[],
) => {
  if (selectedBookings.length >= sortedBookings.length) {
    selectAll([]);
  } else {
    const ids = sortedBookings.map((booking) => booking.uuid);
    selectAll(ids);
  }
};

export const sortBookingsBy = (bookings: IBookingSimple[], sortBy: string) => {
  switch (sortBy) {
    case 'datedesc':
      return bookings.sort((a, b) => SortByDateDescending(a.createdDate, b.createdDate));
    case 'nameasc':
      return bookings.sort((a, b) =>
        SortByNameAscending(a.customer.lastname ?? '', b.customer.lastname ?? ''),
      );
    case 'namedesc':
      return bookings.sort((a, b) =>
        SortByNameDescending(a.customer.lastname ?? '', b.customer.lastname ?? ''),
      );
    case 'dateasc':
    default:
      return bookings.sort((a, b) => SortByDateAscending(a.createdDate, b.createdDate));
  }
};

export const markBookingAsAction = (action: any) => (
  markAs: PresenceType,
  bookings: IPresenceUpdate[],
) => action(bookings.map((booking) => ({ ...booking, presenceType: markAs })));

export const addProductBookingAction = (action: any) => (
  productToAdd: string,
  bookings: IBookingSimple[],
) => action(productToAdd, bookings);

export const updateBookingStatus = (action: any) => (
  bookingStatus: BookingStatus,
  bookings: IBookingSimple[],
) =>
  action(
    bookings.map((booking) => ({
      ...booking,
      bookingStatus,
      presenceType: booking.presenceType,
    })),
  );
